module.exports = __webpack_public_path__ + "gift.svg?1434bf005c4f51a318600e24bead1595";